<a [routerLink]="'/checkout'"
   [class._is-disabled]="disabled"
   cy-checkoutProceed
   [buttonStyle]
   class="w-12">
    {{'checkout securely'|translate}}
</a>

@if(disabled){
@if (!basket.isSalable) {
<p class="p2 col-2 m-t center">{{'To proceed to checkout please remove out of stock products from your basket' |
    translate}}
</p>
}
@if(basket.data.checkout_disallow && basket.data.checkout_disallow_message){
<p class="p2 col-2 m-t center">{{basket.data.checkout_disallow_message | translate}}</p>
}
}